import { CircularProgress, type CircularProgressProps } from '@mui/material';
import { composeSx } from '../../utils/composeSx';
import { HFBox } from '../HFBox';

export type HFSpinnerProps = CircularProgressProps & {
  /** Fill the parent and center the indicator (route/page loaders). */
  center?: boolean;
};

export function HFSpinner({ center, sx, ...props }: HFSpinnerProps) {
  const spinner = <CircularProgress color="primary" sx={center ? undefined : sx} {...props} />;
  if (!center) return spinner;
  return (
    <HFBox
      sx={composeSx(
        {
          display: 'grid',
          placeItems: 'center',
          flex: 1,
          alignSelf: 'stretch',
          width: '100%',
          minHeight: '100%',
        },
        sx,
      )}
    >
      {spinner}
    </HFBox>
  );
}
